import React, { useState, useEffect } from 'react';

const LessonNoteModal = ({ visible, onClose, lessonKey, lessonTitle, onSave, onDelete, initialNote }) => {
  const [note, setNote] = useState('');
  const [homework, setHomework] = useState('');
  const [homeworkDelivered, setHomeworkDelivered] = useState(false);

  useEffect(() => {
    if (initialNote) {
      setNote(initialNote.note || '');
      setHomework(initialNote.homework || '');
      setHomeworkDelivered(initialNote.homeworkDelivered || false);
    } else {
      setNote('');
      setHomework('');
      setHomeworkDelivered(false);
    }
  }, [initialNote, visible]);

  if (!visible) return null;

  const handleSave = () => {
    if (!note.trim() && !homework.trim()) return;
    onSave({
      note: note.trim(),
      homework: homework.trim(),
      homeworkDelivered,
      updatedAt: Date.now(),
    });
    onClose();
  };

  const handleDelete = () => {
    if (onDelete) onDelete();
    onClose();
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-header__title">
            <ion-icon name="document-text" style={{ marginRight: 8, verticalAlign: 'middle', color: 'var(--accent)' }}></ion-icon>
            Заметка
          </h3>
          <button className="modal-header__close" onClick={onClose}>
            <ion-icon name="close" style={{ fontSize: 22 }}></ion-icon>
          </button>
        </div>
        <div className="modal-body">
          {lessonTitle && (
            <p style={{ fontSize: 14, color: 'var(--text-secondary)', marginBottom: 16 }}>
              {lessonTitle}
            </p>
          )}

          <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>
            Заметка
          </label>
          <textarea
            value={note}
            onChange={e => setNote(e.target.value)}
            placeholder="Введите заметку..."
            rows={3}
            style={{
              width: '100%',
              padding: '10px 14px',
              borderRadius: 12,
              border: '0.5px solid var(--border)',
              background: 'var(--surface-secondary)',
              color: 'var(--text)',
              fontFamily: 'inherit',
              fontSize: 14,
              resize: 'vertical',
              outline: 'none',
              marginBottom: 12,
            }}
          />

          <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>
            Домашнее задание
          </label>
          <textarea
            value={homework}
            onChange={e => setHomework(e.target.value)}
            placeholder="Введите домашнее задание..."
            rows={3}
            style={{
              width: '100%',
              padding: '10px 14px',
              borderRadius: 12,
              border: '0.5px solid var(--border)',
              background: 'var(--surface-secondary)',
              color: 'var(--text)',
              fontFamily: 'inherit',
              fontSize: 14,
              resize: 'vertical',
              outline: 'none',
              marginBottom: 12,
            }}
          />

          {homework.trim() && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 14px',
                background: 'var(--surface-tertiary)',
                borderRadius: 12,
                marginBottom: 16,
              }}
            >
              <span style={{ fontSize: 14, color: 'var(--text)' }}>Задание сдано</span>
              <div
                className={`toggle ${homeworkDelivered ? 'toggle--active' : ''}`}
                onClick={() => setHomeworkDelivered(!homeworkDelivered)}
              >
                <div className="toggle__knob" />
              </div>
            </div>
          )}

          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn--primary" style={{ flex: 1 }} onClick={handleSave}>
              Сохранить
            </button>
            {initialNote && (
              <button className="btn btn--secondary" onClick={handleDelete}>
                <ion-icon name="trash-outline" style={{ fontSize: 18 }}></ion-icon>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LessonNoteModal;
